// Friendly line-art doodles inspired by the Young Engineers flyer.
// Decorative only — aria-hidden, pointer-events-none.

const base = "pointer-events-none select-none absolute";

export function DoodleRocket({ className = "", color = "#123B6D" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" className={`${base} ${className}`}>
      <path d="M24 6c6 4 9 11 8 19l-5 5h-6l-5-5c-1-8 2-15 8-19Z" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
      <circle cx="24" cy="19" r="3.4" stroke={color} strokeWidth="2.2" />
      <path d="M16 28l-5 7 8-2M32 28l5 7-8-2" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M24 34v6" stroke="#FF8C42" strokeWidth="2.2" strokeLinecap="round" strokeDasharray="2.5 3.5" />
    </svg>
  );
}

export function DoodleGear({ className = "", color = "#8B5CF6" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" className={`${base} ${className}`}>
      <circle cx="24" cy="24" r="7" stroke={color} strokeWidth="2.2" />
      <circle cx="24" cy="24" r="2.4" stroke={color} strokeWidth="2" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
        <line
          key={a}
          x1={24 + 10 * Math.cos((a * Math.PI) / 180)}
          y1={24 + 10 * Math.sin((a * Math.PI) / 180)}
          x2={24 + 14 * Math.cos((a * Math.PI) / 180)}
          y2={24 + 14 * Math.sin((a * Math.PI) / 180)}
          stroke={color}
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
}

export function DoodleBulb({ className = "", color = "#F59E0B" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" className={`${base} ${className}`}>
      <path d="M24 8a11 11 0 0 1 6 20c-1.4 1-2 2.4-2 4h-8c0-1.6-.6-3-2-4a11 11 0 0 1 6-20Z" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M20 36h8M21.5 40h5" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M24 2v3M38 9l-2.2 2.2M10 9l2.2 2.2" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function DoodlePlus({ className = "", color = "#00A6B2" }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" className={`${base} ${className}`}>
      <path d="M10 3v14M3 10h14" stroke={color} strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}
